module.exports = __webpack_public_path__ + "static/media/boba.070a4f18.jpeg";